import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../store/services/auth.service';

@Component({
  selector: 'app-entrance',
  templateUrl: './entrance.component.html',
  styleUrls: ['./entrance.component.sass']
})
export class EntranceComponent implements OnInit {

  constructor(
    private auth: AuthService,
  ) { }

  ngOnInit() {
    this.auth.login();
  }

  login() {
    this.auth.login();
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/entrance/entrance.component.ts